import type { InjectionKey, Ref } from 'vue'
import type { Marker, ScoreLevel } from '@/shared/graphql/router/graphql'

type TimelineMatchType = 'Audio' | 'Video' | 'Transcript' | 'Text' | 'Image'

interface TimelineRange {
  start: number
  end: number
}

export interface TimelineMatch {
  id: string
  type: TimelineMatchType
  level: ScoreLevel
  title: string
  score: number
  number: number
  location?: string
  markers?: Array<Marker | null>
  registered: TimelineRange
  infringing: TimelineRange
}

export interface TimelineSideMatch {
  id: string
  start: number
  end: number
  level: ScoreLevel
  match: TimelineMatch
}

export interface TimelineAnchor {
  x: number
  top: number
  bottom: number
}

interface TimelineHoverState {
  hoveredId: Ref<string | null>
  hoveredMatch: Ref<TimelineMatch | null>
  hoveredAnchor: Ref<TimelineAnchor | null>
  enter: (
    match: TimelineMatch,
    anchor: TimelineAnchor,
    options?: { sticky?: boolean }
  ) => void
  hide: () => void
}

export const TimelineHoverKey: InjectionKey<TimelineHoverState> =
  Symbol('TimelineHoverState')

const hoverQuery =
  typeof window !== 'undefined' && window.matchMedia
    ? window.matchMedia('(hover: hover) and (pointer: fine)')
    : null

export const canHover = () => hoverQuery?.matches ?? false
